// The command dialogs the player page hosts (spec/dashboard.md section 11.2): one open at a time, mounted only while open.
import type { Player, SaveVersion } from '../../api/types';
import type { ReleaseInfo } from '../../players/releaseCatalog';
import { BanDialog, EraseDialog, ExportDialog, ResetDialog, UnbanDialog } from './CommandDialogs';
import { RestoreAtDialog, RestoreVersionDialog } from './RestoreDialogs';

export type CommandName = 'export' | 'reset' | 'erase' | 'ban' | 'unban';

export interface CommandDialogsHostProps {
  env: string;
  player: Player;
  release: ReleaseInfo;
  command: CommandName | null;
  onCloseCommand: () => void;
  restoreVersion: SaveVersion | null;
  onCloseRestore: () => void;
  restoreAt: { collection?: string } | null;
  onCloseRestoreAt: () => void;
}

export function CommandDialogsHost({ env, player, release, command, onCloseCommand, restoreVersion, onCloseRestore, restoreAt, onCloseRestoreAt }: CommandDialogsHostProps) {
  return (
    <>
      <ExportDialog env={env} player={player} open={command === 'export'} onClose={onCloseCommand} />
      <ResetDialog env={env} player={player} release={release} open={command === 'reset'} onClose={onCloseCommand} />
      <EraseDialog env={env} player={player} open={command === 'erase'} onClose={onCloseCommand} />
      <BanDialog env={env} player={player} open={command === 'ban'} onClose={onCloseCommand} />
      <UnbanDialog env={env} player={player} open={command === 'unban'} onClose={onCloseCommand} />
      <RestoreVersionDialog env={env} player={player} version={restoreVersion} onClose={onCloseRestore} />
      <RestoreAtDialog env={env} player={player} open={!!restoreAt} collection={restoreAt?.collection} onClose={onCloseRestoreAt} />
    </>
  );
}
